module.exports = __webpack_public_path__ + "img/DECHubTermsOfServiceEN.d8a594ab.jpg";